import type { Component } from 'vue'

import { IconGift } from '@ds/icons/IconGift'
import { IconQuality } from '@ds/icons/IconQuality'
import { IconShop } from '@ds/icons/IconShop'
import { IconSmartphone } from '@ds/icons/IconSmartphone'
import { IconSparkles } from '@ds/icons/IconSparkles'
import { IconSwap } from '@ds/icons/IconSwap'

const NAV_ICON_MAP: Record<string, Component> = {
  Sparkles: IconSparkles,
  Swap: IconSwap,
  IconGift,
  Shop: IconShop,
  Quality: IconQuality,
  Smartphone: IconSmartphone,
}

export function resolveNavIcon(iconName: string): Component | undefined {
  return NAV_ICON_MAP[iconName]
}

export function resolveServiceIcon(iconName: string): Component {
  return iconName === 'trade-in' ? IconSwap : IconSparkles
}
